module.exports = __webpack_public_path__ + "img/programme3.7708116d.png";